import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddDiscountLayer from "../../components/ManageDiscount/DiscountFormPage";

const DiscountUpdate = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Discount Management" url="/discount" title1="Update Discount"  />

        <AddDiscountLayer />
      </MasterLayout>
    </>
  );
};

export default DiscountUpdate;
